import type { Group } from '../schema/group';
import { parseCharacteristicArray } from './parseCharacteristic';
import { boolFromStringFlag, intFromMixed, localized } from './coerce';

export function parseGroupArray(raw: unknown): Group[] {
    if (!Array.isArray(raw)) return [];
    // Sort by sort_order — mirrors legacy storage.js:1129
    // (`options.sort(compareOptions)`). Admin Drag&Drop reorder mutates
    // sort_order fields without rewriting array insertion order, so we
    // must normalise here for the form to honor the user's intent.
    return raw.map(parseGroup).sort((a, b) => a.sortOrder - b.sortOrder);
}

function parseGroup(raw: unknown): Group {
    const r = (raw ?? {}) as Record<string, unknown>;
    const altTitle = typeof r.alt_title === 'string' ? r.alt_title.trim() : '';
    return {
        id: intFromMixed(r.id, 0),
        ...(altTitle !== '' ? { altTitle } : {}),
        title: localized(r.title),
        sortOrder: intFromMixed(r.sort_order, 0),
        hidden: boolFromStringFlag(r.hide),
        characteristics: parseCharacteristicArray(r.options),
    };
}
